define("shared/components/shared/post/secondary/caption-writer/upgrade-button", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.shouldDisplayUpgradeButton}}
    <Shared::Button::Upgrade
      @confirmLeave={{true}}
      @feature={{this.upgradeButtonFeature}}
      @location="caption_writer"
      @seamlessCheckoutSuccessCallback={{@onSeamlessCheckoutSuccess}}
      @text={{@text}}
      @variant={{@variant}}
      class="qa--credit-counter_upgrade_plan_btn"
      data-test-id="ai-caption-upgrade-button"
      ...attributes
    />
    {{#if @showUpgradeNote}}
      <p class="u--text--sm u--text--light u--m__t__sm">
        {{t "caption_writer.info_modal.upgrade_note"}}
      </p>
    {{/if}}
  {{/if}}
  */
  {
    "id": "JJS/KpGq",
    "block": "[[[41,[30,0,[\"shouldDisplayUpgradeButton\"]],[[[1,\"  \"],[8,[39,1],[[24,0,\"qa--credit-counter_upgrade_plan_btn\"],[24,\"data-test-id\",\"ai-caption-upgrade-button\"],[17,1]],[[\"@confirmLeave\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@text\",\"@variant\"],[true,[30,0,[\"upgradeButtonFeature\"]],\"caption_writer\",[30,2],[30,3],[30,4]]],null],[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[10,2],[14,0,\"u--text--sm u--text--light u--m__t__sm\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"caption_writer.info_modal.upgrade_note\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[]],null]],[\"&attrs\",\"@onSeamlessCheckoutSuccess\",\"@text\",\"@variant\",\"@showUpgradeNote\"],false,[\"if\",\"shared/button/upgrade\",\"t\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/upgrade-button.hbs",
    "isStrictMode": false
  });
  let UpgradeButtonComponent = _exports.default = (_class = class UpgradeButtonComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
    }
    get currentPlan() {
      return this.subscriptions.planType;
    }
    get shouldDisplayUpgradeButton() {
      const upgradeablePlans = ['free', 'starter', 'creator', 'growth', 'starter202506', 'growth202506'];
      return upgradeablePlans.includes(this.currentPlan);
    }
    get upgradeButtonFeature() {
      if (this.currentPlan === 'free' || this.auth.currentAccount.isOnLegacyPlan) {
        return 'aiCaptionWriterStarter';
      }
      if (this.currentPlan.includes('growth')) {
        return 'aiCaptionWriterScale';
      }
      return 'aiCaptionWriterGrowth';
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, UpgradeButtonComponent);
});